import { useVisitorData } from "@fingerprint/react";
import {
  LS_FPJS_REQUEST_ID,
  LS_FPJS_VISITOR_ID,
} from "../components/constants";

export const useFPJSData = () => {
  const { getData } = useVisitorData({
    immediate: false,
  });

  const setNewLocalstorageFPJSData = async ({
    linkedId = null,
    isForChrome = false,
  }) => {
    try {
      const fpjsData = await getData({
        ...(linkedId && { linkedId }),
      });

      if (fpjsData) {
        localStorage.setItem(LS_FPJS_VISITOR_ID, fpjsData.visitor_id);
        localStorage.setItem(LS_FPJS_REQUEST_ID, fpjsData.event_id);
      }
    } catch (error) {
      console.error("Error in setting FPJS data in localstorage", error);
    }
  };

  return {
    setNewLocalstorageFPJSData,
  };
};
